import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(() => ({
    settingText: {
        fontSize: '15px',
        marginBottom: '5px'
    }
}));
